import axios from 'axios'
import store from '..'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getReservationPropertyInfo ({ state }, property) {
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-reservation-property-info&siteid=${API.SITE_INFO.site}&property=${property}`)
        const propertyData = res.data.message.find(x => x.property === property)
        return propertyData ? res.data.message.find(x => x.property === property).payload : false
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    async setReservation ({ state }, data) {
      try {
        const guestInfo = store.state.guest.guestInfo
        const siteInfo = store.state.authentication
        const spaceid = siteInfo.space
        const ota = store.state.authentication.public ? await store.dispatch('authentication/getOtaKey') : siteInfo.k
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-make-reservation',
          func: 'create',
          siteid: siteInfo.site,
          returnUrl: data.returnUrl,
          payload: {
            ...data.payload,
            ...ota && {
              userInfo: {
                ota: ota,
                ...guestInfo && {
                  ...guestInfo.stayAfter && {
                    stayAfter: guestInfo.stayAfter
                  },
                  ...guestInfo.stayBefore && {
                    stayBefore: guestInfo.stayBefore
                  }
                }
              }
            }
          },
          ...spaceid && {
            spaceid: spaceid
          },
          ...ota && {
            userInfo: {
              ota: ota,
              ...guestInfo && {
                ...guestInfo.stayAfter && {
                  stayAfter: guestInfo.stayAfter
                },
                ...guestInfo.stayBefore && {
                  stayBefore: guestInfo.stayBefore
                }
              }
            }
          }
        })
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    async getReservationRealtime ({ state }, data) {
      try {
        const siteInfo = store.state.authentication
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-get-reservation',
          func: 'read',
          siteid: siteInfo.site,
          spaceId: data.spaceId,
          ...data.date && {
            day: data.date
          },
          ...data.ota && {
            ota: data.ota
          }
        })
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    async getReservationInfo ({ state }, reservationId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-reservation',
          func: 'info',
          order_uuid: reservationId
        })
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    async cancelReservation ({ state }, reservationId) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-reservation',
          func: 'cancel',
          order_uuid: reservationId
        })
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    // test
    async deleteReservation ({ state }, data) {
      try {
        const siteInfo = store.state.authentication
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-test',
          func: 'deleteAll',
          siteid: siteInfo.site,
          spaceId: data.spaceId,
          ...(data.date) && {
            day: data.date
          }
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    // test
    async deleteReservationItem ({ state }, data) {
      try {
        const siteInfo = store.state.authentication
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-test',
          func: 'deleteOne',
          siteid: siteInfo.site,
          spaceId: data.spaceId,
          order_uuid: data.orderId
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    }
  },
  getters: {
  }
}
